
import { useState } from 'react';

export default function ConsultationCTA() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    preferredDate: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('preferredDate', formData.preferredDate);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d661rsfnq3t8fkvccge0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSuccess(true);
        setFormData({ name: '', email: '', phone: '', preferredDate: '', message: '' });
        setTimeout(() => {
          setShowModal(false);
          setSuccess(false);
        }, 2000);
      }
    } catch (error) {
      console.error('送信エラー:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <section id="consultation" className="py-28 px-6">
        <div className="max-w-4xl mx-auto bg-[#1A2B4A] rounded-3xl p-16 text-center">
          <div className="text-sm font-semibold text-[#90CAF9] tracking-widest mb-5">FREE CONSULTATION</div>
          
          <h2 className="text-4xl font-bold text-white mb-8">
            まずは30分の無料相談から
          </h2>
          
          <p className="text-base leading-relaxed text-[#E3F2FD] mb-10">
            無理な勧誘は一切ありません。
          </p>
          
          <div className="flex justify-center">
            <a
              href="https://office4c.wixsite.com/my-site-1/booking-calendar/30分無料相談?referral=service_list_widget"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-12 py-5 bg-white text-[#1A2B4A] rounded-lg font-semibold text-lg hover:bg-[#E3F2FD] transition-colors whitespace-nowrap cursor-pointer"
            >
              今すぐ無料相談を予約する
            </a>
          </div>
          
          <p className="text-[13px] text-[#90CAF9] mt-5">
            所要時間: 30分 / オンライン対応
          </p>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6" onClick={() => setShowModal(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-lg w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-[#1A2B4A]">無料相談予約</h3>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 flex items-center justify-center cursor-pointer">
                <i className="ri-close-line text-2xl text-gray-500"></i>
              </button>
            </div>

            {success ? (
              <div className="text-center py-8">
                <i className="ri-check-circle-line text-6xl text-green-500 mb-4"></i>
                <p className="text-lg font-semibold text-[#2C2C2C]">予約を受け付けました</p>
                <p className="text-sm text-[#5A5A5A] mt-2">担当者より折り返しご連絡いたします</p>
              </div>
            ) : (
              <form id="consultation-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">お名前 <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                    placeholder="山田太郎"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">メールアドレス <span className="text-red-500">*</span></label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                    placeholder="example@email.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">電話番号 <span className="text-red-500">*</span></label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                    placeholder="090-1234-5678"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">希望日時 <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="preferredDate"
                    value={formData.preferredDate}
                    onChange={(e) => setFormData({...formData, preferredDate: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1]"
                    placeholder="例: 2025年1月15日 14:00〜"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2">ご質問・ご相談内容</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#0D47A1] resize-none"
                    placeholder="事前にお聞きしたいことがあればご記入ください"
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500文字</p>
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full py-4 bg-[#1A2B4A] text-white rounded-lg font-semibold hover:bg-[#0D47A1] transition-colors disabled:opacity-50 whitespace-nowrap cursor-pointer"
                >
                  {submitting ? '送信中...' : '予約する'}
                </button>

                <p className="text-xs text-center text-[#5A5A5A]">
                  送信後、担当者より24時間以内にご連絡いたします
                </p>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
